import { Stack, SxProps, Theme } from "@mui/material";

import SimpleCardSkeleton from "./SimpleCardSkeleton";

export interface SimpleCardListSkeletonProps {
  itemCount?: number;
  sx?: SxProps<Theme>;
}

export default function SimpleCardListSkeleton({ itemCount = 3, sx }: SimpleCardListSkeletonProps) {
  return (
    <Stack spacing={1} sx={{ width: "100%", ...sx }}>
      {Array.from({ length: itemCount }).map((x, i) => (
        <SimpleCardSkeleton key={i} />
      ))}
    </Stack>
  );
}
